import { IconProps } from "./type";

const WithdrawIcon = ({ className }: IconProps) => {
  return (
    <svg
      width="66"
      height="66"
      viewBox="0 0 66 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <foreignObject x="0" y="0" width="0" height="0">
        <div></div>
      </foreignObject>
      <circle
        data-figma-bg-blur-radius="4"
        cx="33"
        cy="33"
        r="32.5"
        transform="rotate(-180 33 33)"
        fill="#F4E7FF"
        stroke="#F4E7FF"
      />
      <path
        d="M28.4287 19.2852H42.143"
        stroke="#714790"
        stroke-width="2.5"
        stroke-linecap="round"
      />
      <path
        d="M24.7576 41.8882L41.7281 24.9176M42.5363 37.0395V24.1095H29.6063"
        stroke="#714790"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <defs>
        <clipPath id="bgblur_0_45_98803_clip_path" transform="translate(0 0)">
          <circle cx="33" cy="33" r="32.5" transform="rotate(-180 33 33)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default WithdrawIcon;
